import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { useNavigate } from 'react-router-dom';

import classnames from "classnames";

// core components
import Navbar from "../layouts/Navbar.js";

import '../../assets/css/Login.css'

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Input,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faKey } from "@fortawesome/free-solid-svg-icons";

export default function Login() {
  const [isLoading, setIsLoading] = useState(false);

  const [errorMessages, setErrorMessages] = useState({});

  const [emailFocus, setEmailFocus] = useState(false);
  const [passwordFocus, setPasswordFocus] = useState(false);

  const navigate = useNavigate();
  
  useEffect(() => {
    document.documentElement.addEventListener("mousemove", followCursor);
    // Specify how to clean up after this effect:
    return function cleanup() {
      document.documentElement.removeEventListener("mousemove", followCursor);
    };
  }, []);

  const login = async (e) => {
    e.preventDefault();

    //로딩중 표기
    setIsLoading(true);

    setErrorMessages({ errors : "" });

    const fields = ["username", "password"];
    const formElements = e.target.elements;

    const formValues = fields
      .map((field) => ({
        [field]: formElements.namedItem(field).value,
      }))
      .reduce((current, next) => ({ ...current, ...next }));

    let loginRequest;

    //console.log("Submit Form data : " + JSON.stringify(formValues));

    try {
      //alert("login start"+process.env.REACT_APP_SERVER_URL);
      loginRequest = await axios.post(
        `/login`,
        // `${process.env.REACT_APP_SERVER_URL}/login`,
        {
          ...formValues,
        },
        { baseURL : process.env.REACT_APP_SERVER_URL },
        // { baseURL : "https://intospace.co.kr:8001" },
        {
          withCredentials: true
        });
        

    } catch ({ response }) {
      loginRequest = response;
      alert("Login Failed!!\n" + JSON.stringify(loginRequest.data.messages.errors));
      
    }

    const { data: loginRequestData } = loginRequest;

    //console.log("loginRequestData : " + JSON.stringify(loginRequestData));

    if (loginRequestData.success) {
      alert("로그인에 성공하였습니다. 메인 페이지로 이동합니다");
      // 성공 후 메인페이지로 이동
      return navigate("/");

    } else {
      setIsLoading(false);
      const messages  = loginRequestData.messages;

      if (messages && messages.errors) {
        setErrorMessages({ errors : messages.errors });
      }

      if(messages.errors === {}){
        alert("로그인에 문제가 발생하였습니다. 다시 시도해 주세요")
      }

      if(messages.errors && messages.errors.email) {
        setEmailFocus(true);
      }

      if(messages.errors && messages.errors.password) {
        setPasswordFocus(true);
      }
    }
  };

  /* followCursor Function */
  const [squares1to6, setSquares1to6] = useState("");
  const [squares7and8, setSquares7and8] = useState("");

  const followCursor = (e => {
    let posX = e.clientX - window.innerWidth / 2;
    let posY = e.clientY - window.innerWidth / 6;
    setSquares1to6(
      "perspective(500px) rotateY(" +
        posX * 0.05 +
        "deg) rotateX(" +
        posY * -0.05 +
        "deg)"
    );
    setSquares7and8(
      "perspective(500px) rotateY(" +
        posX * 0.02 +
        "deg) rotateX(" +
        posY * -0.02 +
        "deg)"
    );
  })

  return (
    <>
    <Navbar/ >
      <div className="wrapper register-page">
        <div className="page-header">
          <div className="page-header-image" />
          <div className="content" id="loginContent">
            <Container>
              <Row>
                <Col>
                  <Card className="card-register">
                    <form className="form" onSubmit={login}>
                    <CardHeader>
                      <CardTitle>Login</CardTitle>
                    </CardHeader>
                    {isLoading ? (
                      // 로딩 중일 때 로딩 스피너 또는 메시지 표시
                      <div className="loader" style={{height:'50%'}}>
                        <div className="loader-container" style={{marginTop:'-30px'}}>
                          <p className='loader-title'>Loading...</p>
                        </div>
                      </div>
                    ) : (<></>)}
                    <CardBody>
                        <InputGroup
                          className={classnames({
                            "input-group-focus": emailFocus,
                          })}
                        >
                          <InputGroupText>
                            <FontAwesomeIcon icon={faEnvelope} />
                          </InputGroupText>
                          <Input
                            placeholder="Email(ID)"
                            type="email"
                            id="email"
                            required
                            name= "username"
                            onFocus={(e) => setEmailFocus(true)}
                            onBlur={(e) => setEmailFocus(false)}
                          />
                        </InputGroup>
                        <InputGroup
                          className={classnames({
                            "input-group-focus": passwordFocus,
                          })}
                        >
                          <InputGroupText>
                            <FontAwesomeIcon icon={faKey} />
                          </InputGroupText>
                          <Input
                            placeholder="Password"
                            type="password"
                            id="password"
                            required
                            name= "password"
                            onFocus={(e) => setPasswordFocus(true)}
                            onBlur={(e) => setPasswordFocus(false)}
                          />
                        </InputGroup>

                        
                        {errorMessages.errors && (
                          <div className="errorMessage" style={{ color: 'red', marginBottom:'10px' }}>{errorMessages.errors.email}</div>
                        )}

                        {errorMessages.errors && (
                          <div className="errorMessage" style={{ color: 'red', marginBottom:'10px' }}>{errorMessages.errors.password}</div>
                        )}

                        {errorMessages.errors && (
                          <div className="errorMessage" style={{ color: 'red' }}>{errorMessages.errors.invalidEmailOrPassword}</div>
                        )}

                    </CardBody>
                    <CardFooter>
                      <Button type="submit" className="itsBtnDefault" size="md">
                        로그인
                      </Button>
                      {/* <a href="/Register"> */}
                        <Button type="button" className="itsBtnGray" size="md"
                        onClick={() => alert('서비스 안정화를 위해 회원가입을 제한 하고있습니다.\nID 생성 및 기타 문의는 서비스 문의기능을 이용해주세요 .')}
                        >
                          회원가입
                        </Button>
                      {/* </a> */}
                    </CardFooter>
                    </form>
                  </Card>
                </Col>
              </Row>
              <div
                className="square square-7"
                id="square7"
                style={{ transform: squares7and8 }}
              />
              <div
                className="square square-8"
                id="square8"
                style={{ transform: squares7and8 }}
              />
              <div
                className="square square-1"
                id="square1"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-2"
                id="square2"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-3"
                id="square3"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-4"
                id="square4"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-5"
                id="square5"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-6"
                id="square6"
                style={{ transform: squares1to6 }}
              />
            </Container>
          </div>
        </div>
      </div>
    </>
  );
}